import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {DetailedSalesReportModel} from "./detailed-sales-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-detailed-sales-report",
    templateUrl: "./detailed-sales-report.component.html",
    providers: [provideReportModel(DetailedSalesReportModel)]
})
export class DetailedSalesReportComponent extends AbstractReportPage {

    constructor(public model: DetailedSalesReportModel) {
        super();
    }

    handleInvoiceNo(): void {
        if (!this.model.data.invoiceNo) {
            this.model.data.receiptno = "";
        }
    }
}
